import { IrrigationEventProto } from "./IrrigationEventProto.js";

export const currentScheduleTrackerTick = 0;

export class HashedDaySchedule {
    hashString: string;
    date: Date;
    pendingChanges: (() => void)[] = [];
    tickOfLastChange: number;
    removedEvents: Set<IrrigationEventProto> = new Set();
    addedEvents: Set<IrrigationEventProto> = new Set();
    changedEvents: Set<IrrigationEventProto> = new Set();

    includedEvents: Set<IrrigationEventProto> = new Set();
    constructor(date: Date, zoneID: string) {
        this.hashString = HashedDaySchedule.getHashString(date, zoneID);
        this.date = date;
    }

    listenersByKey: Record<
        string,
        (
            addedEvents: Set<IrrigationEventProto>,
            changedEvents: Set<IrrigationEventProto>,
            removedEvents: Set<IrrigationEventProto>,
            record: HashedDaySchedule,
        ) => void
    > = {};
    addChangeListener(
        listener: (
            addedEvents: Set<IrrigationEventProto>,
            changedEvents: Set<IrrigationEventProto>,
            removedEvents: Set<IrrigationEventProto>,
            record: HashedDaySchedule,
        ) => void,
        key: string,
    ): void {
        this.listenersByKey[key] = listener;
    }
    removeListener(key: string): void {
        delete this.listenersByKey[key];
    }

    activate(): void {
        if (this.pendingChanges.length > 0) {
            const originalEventSet = new Set(Array.from(this.includedEvents));
            //clear changelist
            this.addedEvents = new Set();
            this.removedEvents = new Set();
            this.changedEvents = new Set();

            //run tick;
            for (let i = 0; i < this.pendingChanges.length; i++) {
                this.pendingChanges[i]();
            }
            this.pendingChanges = [];
            this.tickOfLastChange = currentScheduleTrackerTick;
            //clean changelist
            Array.from(this.addedEvents).forEach((e) => {
                if (this.removedEvents.has(e)) {
                    //if it used to be included and now is not, then it should be deleted and not readded
                    if (originalEventSet.has(e) && !this.includedEvents.has(e)) {
                        this.addedEvents.delete(e);
                        this.changedEvents.delete(e);
                    }
                    //if it wasn't previously included but is now then it should be added and not removed.
                    else if (!originalEventSet.has(e) && this.includedEvents.has(e)) {
                        this.removedEvents.delete(e);
                        this.changedEvents.delete(e);
                    }
                    //if it's inclusion status hasn't changed, flag it as needing an update.
                    else {
                        this.removedEvents.delete(e);
                        this.addedEvents.delete(e);
                        this.changedEvents.add(e);
                    }
                } else {
                    this.changedEvents.delete(e);
                }
            });
            Array.from(this.removedEvents).forEach((e) => {
                if (this.changedEvents.has(e)) {
                    this.changedEvents.delete(e);
                }
            });
            Array.from(this.changedEvents).forEach((e) => {
                if (!this.includedEvents.has(e)) {
                    this.includedEvents.add(e);
                    this.addedEvents.add(e);
                }
            });
            //run listeners
            Object.keys(this.listenersByKey).forEach((k) => {
                this.listenersByKey[k](this.addedEvents, this.changedEvents, this.removedEvents, this);
            });
        }
    }
    addEvent(event: IrrigationEventProto): void {
        this.pendingChanges.push(() => {
            this.addedEvents.add(event);
            this.includedEvents.add(event);
        });
    }
    removeEvent(event: IrrigationEventProto): void {
        this.pendingChanges.push(() => {
            this.removedEvents.add(event);
            this.includedEvents.delete(event);
        });
    }
    flagChanges(event: IrrigationEventProto): void {
        this.pendingChanges.push(() => {
            this.changedEvents.add(event);
        });
    }

    static addEventToHashTable(event: IrrigationEventProto): HashedDaySchedule {
        const record = HashedDaySchedule.getHashRecord(event.startTime, event.zoneID);
        record.addEvent(event);
        return record;
    }
    static flagChangeInHashTable(event: IrrigationEventProto): HashedDaySchedule {
        const record = HashedDaySchedule.getHashRecord(event.startTime, event.zoneID);
        record.flagChanges(event);
        return record;
    }
    static getHashString(date: Date, zoneID: string): string {
        return date.toDateString() + "|" + zoneID;
    }

    static getHashRecord(date: Date, zoneID: string): HashedDaySchedule {
        const hashString = HashedDaySchedule.getHashString(date, zoneID);
        if (!ScheduleHashTable[hashString]) {
            ScheduleHashTable[hashString] = new HashedDaySchedule(date, zoneID);
        }
        return ScheduleHashTable[hashString];
    }
}
let ticking = false;
export function doTick() {
    if (ticking) {
        return;
    }
    ticking = true;
    try {
        const allHashes = Object.values(ScheduleHashTable);
        for (let i = 0; i < allHashes.length; i++) {
            try {
                allHashes[i].activate();
            } catch (e) {
                console.warn("error activating hash for schedule tick");
                console.warn(e);
            }
        }
    } catch (e) {
        console.warn("Error in schedule ticker");
        console.warn(e);
    }
    ticking = false;
}

export const ScheduleHashTable: Record<string, HashedDaySchedule> = {};
